<template>
  <div class="footer">
    <p>copyright © 2021 XX技术有限公司出品</p>
  </div>
</template>

<script setup>
// 页脚组件，用于显示版权信息
</script>

<style scoped>
/* 导入共享样式 */
@import '@/style/shared-styles.css';
</style>